module.exports = __webpack_public_path__ + "img/part5-2.168c18d4.png";